export default {
  rollbarAccessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN || null,
  rollbarEnv: process.env.REACT_APP_ROLLBAR_ENV || null
};
